import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.hideAll()

    // this.heart(1, 1)
    // this.heart(3, 1)

    // this.heart(0, 2)
    // this.heart(1, 2)
    // this.heart(2, 2)
    // this.heart(3, 2)
    // this.heart(4, 2)

    // this.heart(0, 3)
    // this.heart(1, 3)
    // this.heart(2, 3)
    // this.heart(3, 3)
    // this.heart(4, 3)

    // this.heart(1, 4)
    // this.heart(2, 4)
    // this.heart(3, 4)

    // this.heart(2, 5)


    this.heart(1, 1)
    this.heart(5, 1)

    this.heart(0, 2)
    this.heart(1, 2)
    this.heart(2, 2)
    this.heart(5, 2)
    this.heart(4, 2)
    this.heart(6, 2)

    this.heart(0, 3)
    this.heart(1, 3)
    this.heart(2, 3)
    this.heart(3, 3)
    this.heart(4, 3)
    this.heart(5, 3)
    this.heart(6, 3)

    this.heart(0, 4)
    this.heart(1, 4)
    this.heart(2, 4)
    this.heart(3, 4)
    this.heart(4, 4)
    this.heart(5, 4)
    this.heart(6, 4)

    this.heart(1, 5)
    this.heart(2, 5)
    this.heart(3, 5)
    this.heart(4, 5)
    this.heart(5, 5)

    this.heart(2, 6)
    this.heart(3, 6)
    this.heart(4, 6)

    this.heart(3, 7)
  }

  hideAll() {
    this.hideRow(1)
    this.hideRow(2)
    this.hideRow(3)
    this.hideRow(4)
    this.hideRow(5)
    this.hideRow(6)
    this.hideRow(7)
    this.hideRow(8)
  }

  heart(x, y) {
    const td = document.querySelector(`td[data-x='${x}'][data-y='${y}']`)

    const i = document.createElement('i')
    i.classList.add("fa", "fa-heart", "text-danger")
    td.appendChild(i)
  }

  hideRow(y) {
    this.hide(0, y)
    this.hide(1, y)
    this.hide(2, y)
    this.hide(3, y)
    this.hide(4, y)
    this.hide(5, y)
    this.hide(6, y)
    this.hide(7, y)
  }

  hide(x, y) {
    const td = document.querySelector(`td[data-x='${x}'][data-y='${y}']`)
    td.children[0].hidden = true
  }
}
